export default function() {
  // add_to_cart
  const addToCartBtn = document.querySelector('#add-to-cart-btn');

  if(addToCartBtn) {
    addToCartBtn.addEventListener('click', () => {
      let itemPrice = document.querySelector('[data-item-price]').dataset.itemPrice;
      let itemId = document.querySelector('.variant.active').dataset.variantSku;
      let itemName = document.querySelector('[data-item-name]').dataset.itemName;
      let qty = document.querySelector('#item-qty').value;

      window.dataLayer.push({
        event: "add_to_cart",
        currency: window.currency,
        value: Math.round((itemPrice * qty) * 1e2) / 1e2,
        items: [
          {
            item_id: itemId,
            item_name: itemName,
            quantity: Number(qty),
            price: Number(itemPrice)
          }
        ]
      });
    });
  }

  // remove_from_cart
  const updateCartForm = document.querySelector('#update-cart-form');

  if(updateCartForm) {
    updateCartForm.addEventListener('submit', () => {
      let checkedRemoveInputs = document.querySelectorAll('input[type=checkbox][data-gtm-form-interact-field-id]');
      let items = [];
      let subtotals = [];

      if(checkedRemoveInputs.length > 0) {
        checkedRemoveInputs.forEach(item => {
          let productDetails = JSON.parse(item.closest('#item-row').dataset.item);

          let product = {
            item_id: productDetails.sku,
            item_name: productDetails.description,
            quantity: Number(productDetails.qty),
            price: Number(productDetails.price)
          };

          items.push(product);
          subtotals.push(productDetails.total);
        });

        let total = subtotals.reduce((subtotal, current) => {
          return subtotal + current;
        }, 0);

        window.dataLayer.push({
          event: "remove_from_cart",
          currency: window.currency,
          value: Math.round(total * 1e2) / 1e2,
          items: items
        });
      }
    });
  }

  // begin_checkout
  const checkoutBtn = document.querySelector('#checkout-btn');

  if(checkoutBtn) {
    checkoutBtn.addEventListener('click', () => {
      let items = [];
      let cartTotal = document.querySelector('[data-cart-total]').dataset.cartTotal;
      let itemsList = JSON.parse(document.querySelector('[data-items]').dataset.items);

      itemsList.forEach(item => {
        let product = {
          item_id: item.sku,
          item_name: item.description,
          quantity: Number(item.qty),
          price: Number(item.price)
        };

        items.push(product);
      });

      window.dataLayer.push({
        event: "begin_checkout",
        currency: window.currency,
        value: Number(cartTotal),
        items: items
      });
    });
  }

  // view_cart
  const viewCartBtn = document.querySelector('#view-cart-btn');

  if(viewCartBtn) {
    viewCartBtn.addEventListener('click', () => {
      let items = [];
      let cartTotal = document.querySelector('[data-cart-total]').dataset.cartTotal;
      let itemsList = JSON.parse(document.querySelector('[data-items]').dataset.items);

      itemsList.forEach(item => {
        let product = {
          item_id: item.sku,
          item_name: item.description,
          quantity: Number(item.qty),
          price: Number(item.price)
        };

        items.push(product);
      });

      window.dataLayer.push({
        event: "view_cart",
        currency: window.currency,
        value: Number(cartTotal),
        items: items
      });
    });
  }

  // add_shipping_info
  const addressForm = document.querySelector('#address-form');

  if(addressForm) {
      let items = [];
      let cartTotal = document.querySelector('[data-cart-total]').dataset.cartTotal;
      let itemsList = JSON.parse(document.querySelector('[data-items]').dataset.items);

      itemsList.forEach(item => {
        let product = {
          item_id: item.sku,
          item_name: item.description,
          quantity: Number(item.qty),
          price: Number(item.price)
        };

        items.push(product);
      });

      window.dataLayer.push({
        event: "add_shipping_info",
        currency: window.currency,
        value: Number(cartTotal),
        items: items
      });
  }

  // add_payment_info
  const paymentForm = document.querySelector('#paymentForm');

  if(paymentForm) {
    let items = [];
    let cartTotal = document.querySelector('[data-cart-total]').dataset.cartTotal;
    let itemsList = JSON.parse(document.querySelector('[data-items]').dataset.items);

    itemsList.forEach(item => {
      let product = {
        item_id: item.sku,
        item_name: item.description,
        quantity: Number(item.qty),
        price: Number(item.price)
      };

      items.push(product);
    });

    window.dataLayer.push({
      event: "add_payment_info",
      currency: window.currency,
      value: Number(cartTotal),
      items: items
    });
  }

  // GTM purchase event
  const orderConfirmation = document.querySelector('#order-confirmation');

  if (orderConfirmation) {
    let items = [];
    JSON.parse(orderConfirmation.dataset.items).forEach(item => {
      let product = {
        item_id: item.sku,
        item_name: item.description,
        quantity: Number(item.qty),
        price: Number(item.price)
      };
      items.push(product);
    });

    window.dataLayer.push({
      event: "purchase",
      currency: window.currency,
      value: Number(orderConfirmation.dataset.orderTotal),
      transaction_id: orderConfirmation.dataset.orderNumber,
      shipping: Number(orderConfirmation.dataset.shipping),
      tax: Number(orderConfirmation.dataset.tax),
      items: items
    });
  }

  // search
  const searchBar = document.querySelector('#product-search');

  if(searchBar) {
    let searchInput = searchBar.querySelector('input');
    searchBar.addEventListener('submit', () => {
      window.dataLayer.push({
        event: "search",
        search_term: searchInput.value
      });
    });
  }

  // view_item & select_item
  const pageType = document.querySelector('[data-page-type]').dataset.pageType;
  const previousPageCat = document.querySelector('[data-previous-page-cat]').dataset.previousPageCat;
  const previousPageUrl = document.querySelector('[data-previous-page-url]').dataset.previousPageUrl;
  const referrerUrl =  document.querySelector('[data-referrer-url]').dataset.referrerUrl;

  if(pageType == 'textileProduct') {
    let itemPrice = document.querySelector('[data-item-price]')?.dataset.itemPrice;
    let itemId = document.querySelector('.variant.active').dataset.variantSku;
    let itemName = document.querySelector('[data-item-name]').dataset.itemName;


    if(previousPageCat && previousPageUrl === referrerUrl) {
      window.dataLayer.push({
        event: "select_item",
        currency: window.currency,
        value: Number(itemPrice),
        item_list_name: previousPageCat,
        items: [
          {
            item_id: itemId,
            item_name: itemName,
            price: Number(itemPrice)
          }
        ]
      });
    }

    window.dataLayer.push({
      event: "view_item",
      currency: window.currency,
      value: Number(itemPrice),
      items: [
        {
          item_id: itemId,
          item_name: itemName,
          price: Number(itemPrice)
        }
      ]
    });
  }

  // demande_echantillon
  const addSampleBtn = document.querySelector('#add-sample-btn');

  if(addSampleBtn) {
    addSampleBtn.addEventListener('click', () => {
      let itemId = document.querySelector('.variant.active').dataset.variantSampleSku;
      let itemName = document.querySelector('[data-item-name]').dataset.itemName;

      window.dataLayer.push({
        event: "demande_echantillon",
        currency: window.currency,
        items: [
          {
            item_id: itemId,
            item_name: itemName,
          }
        ]
      });
    });
  }

  // sign_up
  const registerForm = document.querySelector('#register-form');

  if(registerForm) {
    let method = document.querySelector('[data-register-method]').dataset.registerMethod;
    registerForm.addEventListener('submit', () => {
      window.dataLayer.push({
        event: "sign_up",
        method: method
      });
    });
  }
}
